module.exports = __webpack_public_path__ + "img/shopping_1.c9929726.svg";